import React from 'react';
import PropTypes from 'prop-types';
import { Image, TouchableOpacity } from 'react-native-web';

import { getBlueSportIcon } from '../../../../../utils/get-sport-icons';
import styles from './styles';

const propTypes = {
  sportName: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
  isPressed: PropTypes.bool.isRequired,
};

/**
 * TODO: Move to shared library
 *
 * @param {Object} props
 * @param {string} props.sportName - required
 * @param {function} props.onPress - required
 * @param {boolean} props.isPressed - required
 * @returns {JSX.Element} SportIconButton component
 */
const SportIconButton = ({ sportName, isPressed, onPress }) => {
  const imageSource = getBlueSportIcon(sportName);

  const onPressIcon = () => {
    if (onPress) onPress(sportName);
  };

  return (
    <TouchableOpacity
      style={[styles.iconContainer, ...(isPressed ? [styles.selected] : [])]}
      onPress={onPressIcon}
    >
      <Image alt={`${sportName}-icon`} style={styles.icon} source={imageSource} />
    </TouchableOpacity>
  );
};

SportIconButton.propTypes = propTypes;

export default SportIconButton;
